<div
    class="widget h-100"
    [ngClass]="widgetSize ? 'widget-' + widgetSize : ''"
    [attr.data-cy]="'widget-' + widgetTitle"
>
    @if (widgetTitle || viewsMenu?.length) {
        <div class="widget-header">
            <h5 class="mb-0 flex-grow-1">
                <div class="widget-header__title d-flex">
                    @if (!viewsMenu?.length) {
                        <span>{{ widgetTitle }}</span>
                        @if ((count || count === 0) && !hideCount) {
                            <span>&nbsp;({{ count }})</span>
                        }
                    } @else {
                        @if (viewsMenu?.length) {
                            <molecule-context-menu-dropdown
                                parentContainer="body"
                                btnClass="h5 btn-link"
                                [placement]="[
                                    'bottom-left',
                                    'top-left',
                                    'bottom-right',
                                    'top-right',
                                ]"
                                [menu]="viewsMenu"
                                [defaultSelectFirst]="true"
                                (singleItemSelected)="onViewSelected($event)"
                                [attr.data-cy]="
                                    'widget-context-menu-' + widgetTitle
                                "
                            ></molecule-context-menu-dropdown>
                        }
                    }
                </div>
            </h5>
            @if (
                spokeButton &&
                spokeButton.position === SPOKE_BUTTON_POSITION.Header
            ) {
                @if (!spokeButton.routerLink) {
                    <button
                        wdxButton="link"
                        data-cy="btn-see-all"
                        [modalId]="spokeButton.modalId"
                        (click)="onSpokeButtonClicked()"
                    >
                        {{ spokeButton.label }}
                    </button>
                } @else {
                    <a
                        wdxButton="link"
                        data-cy="btn-see-all"
                        [routerLink]="spokeButton.routerLink"
                        [queryParams]="spokeButton.queryParams"
                        >{{
                            spokeButton.translationKey
                                | translateTokenisedString
                        }}</a
                    >
                }
            }
            <ng-content select=".widget-header-action-buttons"></ng-content>
        </div>
    }

    @if (filterHandler && sortMenu) {
        <div class="widget-header">
            <molecule-filter-bar
                [showFilters]="false"
                [filterHandler]="filterHandler"
                [sortMenu]="sortMenu"
            ></molecule-filter-bar>
        </div>
    }

    <div
        class="widget-body position-relative"
        [class.overflow-hidden]="!disableOverflowClasses"
        [ngClass]="containerClass"
    >
        @if (!showNoDataMessage || isLoading || hasError) {
            <atom-async-data
                class="d-block h-100"
                [class.overflow-auto]="!disableOverflowClasses"
                [isLoading]="isLoading"
                [hasError]="hasError"
            >
                <ng-content select="div.widget-header"></ng-content>
                <ng-content></ng-content>
            </atom-async-data>
        }

        @if (showNoDataMessage && !isLoading && !hasError) {
            <div class="d-flex h-100 justify-content-center align-items-center">
                <atom-feature-svg size="xs" [svg]="NO_DATA_SVG">
                    {{ noDataMessage | translateTokenisedString }}
                </atom-feature-svg>
            </div>
        }
    </div>

    <ng-content select=".widget-footer"></ng-content>

    @if (
        spokeButton &&
        !(spokeButton | fn: hideSpokeButton : numberToCompareToLimit : limit) &&
        (!spokeButton.position ||
            spokeButton.position === SPOKE_BUTTON_POSITION.Bottom)
    ) {
        <atom-widget-full-width-button
            [attr.data-cy]="'btn-see-all-' + spokeButton.label"
            [modalId]="spokeButton.modalId"
            (click)="onSpokeButtonClicked()"
        >
            {{ spokeButton.label }}
        </atom-widget-full-width-button>
    }
</div>
